export const PUBLISHING_STAGES_CONFIG = [
    { status: 'ENQUIRY', label: 'Enquiry Received', order: 1, description: 'Initial manuscript/proposal submission received and logged.' },
    { status: 'UNDER_REVIEW', label: 'Editorial Assessment', order: 2, description: 'Publishing committee and editorial team reviewing submission.' },
    { status: 'CONSULTATION', label: 'Author Consultation', order: 3, description: 'Strategic publishing alignment, vision, and project scope discussions.' },
    { status: 'PROPOSAL', label: 'Proposal & Quote', order: 4, description: 'Publishing scope, deliverables, timeline, and agreement prepared.' },
    { status: 'CONTRACTED', label: 'Agreement Executed', order: 5, description: 'Publishing contract signed and project team mobilized.' },
    { status: 'MANUSCRIPT_RECEIVED', label: 'Manuscript Intake', order: 6, description: 'Final author source files and assets securely submitted.' },
    { status: 'EDITORIAL', label: 'Editorial & Revisions', order: 7, description: 'Developmental editing, copyediting, proofreading, and author review rounds.' },
    { status: 'DESIGN', label: 'Cover & Interior Design', order: 8, description: 'Custom cover design, typography, interior layout, and typesetting.' },
    { status: 'PRODUCTION', label: 'Proofing & Pre-Press', order: 9, description: 'Pre-flight file preparation, digital proofs, and advance review copy.' },
    { status: 'APPROVAL', label: 'Final Client Approval', order: 10, description: 'Author/client final sign-off on cover, interior, and metadata.' },
    { status: 'PUBLISHED', label: 'Publication & Release', order: 11, description: 'ISBN registration, distribution activation, and official book release.' },
    { status: 'COMPLETED', label: 'Ongoing Support', order: 12, description: 'Post-launch support, catalog archive, and author advisory.' }
];
export const ENQUIRY_STATUS_CONFIG = {
    NEW: { label: 'New', color: 'blue' },
    UNDER_REVIEW: { label: 'Under Review', color: 'amber' },
    CONTACTED: { label: 'Contacted', color: 'indigo' },
    CONSULTATION: { label: 'Consultation', color: 'purple' },
    PROPOSAL_SENT: { label: 'Proposal Sent', color: 'cyan' },
    CONVERTED: { label: 'Converted to Client', color: 'emerald' },
    DECLINED: { label: 'Declined', color: 'rose' },
    ARCHIVED: { label: 'Archived', color: 'slate' }
};
export const PROJECT_STAGES_LIST = [
    { value: 'IDEA_CONCEPT', label: 'Concept / Idea Stage' },
    { value: 'OUTLINE_SYNOPSIS', label: 'Outline & Synopsis Prepared' },
    { value: 'FIRST_DRAFT', label: 'First Draft Completed' },
    { value: 'REVISED_DRAFT', label: 'Revised / Polished Draft' },
    { value: 'COMPLETED_MANUSCRIPT', label: 'Completed Manuscript Ready for Assessment' },
    { value: 'PREVIOUSLY_PUBLISHED', label: 'Previously Published / Rights Reversion' }
];
export const PUBLISHING_GENRES = [
    'Theology & Biblical Studies',
    'Christian Living & Discipleship',
    'Church History & Biography',
    'Apologetics & Philosophy',
    'Pastoral & Ministry Leadership',
    'Commentary & Expository',
    'Devotional & Spiritual Formation',
    'Academic & Theological Monograph',
    'Children & Youth Literature',
    'Christian Fiction & Poetry',
    'Memoir & Personal Testimony',
    'General Non-Fiction / Educational'
];
export const PUBLISHING_REQUIREMENTS_LIST = [
    'Manuscript Assessment',
    'Developmental / Structural Editing',
    'Copy Editing & Proofreading',
    'Custom Book Cover Design',
    'Interior Typesetting & Layout (Print)',
    'eBook Conversion (EPUB / MOBI / PDF)',
    'ISBN & Copyright Administration',
    'Print Production Management (Hardcover / Paperback)',
    'Digital Distribution Preparation',
    'Author Branding & Launch Strategy'
];
export const DOCUMENT_CATEGORIES = [
    { value: 'AGREEMENT', label: 'Contracts & Agreements' },
    { value: 'MANUSCRIPT', label: 'Author Manuscripts' },
    { value: 'EDITORIAL', label: 'Editorial Notes & Tracked Changes' },
    { value: 'PROOF', label: 'Page Proofs & Galleys' },
    { value: 'COVER_DESIGN', label: 'Cover Concepts & Final Art' },
    { value: 'APPROVAL', label: 'Client Sign-offs & Approvals' },
    { value: 'FINAL_FILES', label: 'Final Production Files' },
    { value: 'OTHER', label: 'General / Supporting Documents' }
];
export const ORGANIZATION_LEGAL_NAME = 'FOR THE TRUTH PRESS PRIVATE LIMITED';
export const ORGANIZATION_SHORT_NAME = 'FTT Press Pvt Ltd';
export const PUBLISHING_IMPRINT_NAME = 'For The Truth Publishing';
export const BOOKSTORE_BRAND_NAME = 'For The Truth Bookstore';
export const INDIAN_LANGUAGES_LIST = [
    'Hindi',
    'Tamil',
    'Telugu',
    'Malayalam',
    'Bengali',
    'Marathi',
    'Gujarati',
    'Kannada',
    'Odia',
    'Punjabi',
    'Assamese',
    'Urdu',
    'English'
];
export const TRANSLATION_STAGES_CONFIG = [
    { stage: 'RIGHTS_CLEARANCE', label: 'Rights Clearance', order: 1, description: 'Licensing, copyright clearance, and contract execution with original publisher.' },
    { stage: 'SOURCE_PREPARATION', label: 'Source Text & Glossary', order: 2, description: 'Theological glossary compilation and source chapter segmentation.' },
    { stage: 'INITIAL_DRAFT', label: 'Initial Translation Draft', order: 3, description: 'Language specialist completing chapter-by-chapter vernacular translation.' },
    { stage: 'THEOLOGICAL_REVIEW', label: 'Theological Review', order: 4, description: 'Doctrinal accuracy check and biblical terminology verification by theological reviewer.' },
    { stage: 'PEER_REVIEW', label: 'Linguistic & Peer Review', order: 5, description: 'Syntax, cultural resonance, and readability check by native language peers.' },
    { stage: 'EDITORIAL_POLISH', label: 'Editorial Polish', order: 6, description: 'Senior editor harmonizing voice, style, and grammatical precision.' },
    { stage: 'TYPESETTING_LAYOUT', label: 'Typesetting & Layout', order: 7, description: 'Script-specific Indian font typesetting, ligature calibration, and page layout.' },
    { stage: 'FINAL_PROOF', label: 'Galley Proofing', order: 8, description: 'Pre-press proofreading, index verification, and author/rights holder review.' },
    { stage: 'PRINT_READY', label: 'Pre-Press / Print Ready', order: 9, description: 'Archival pre-flight files, digital EPUB master, and cover stamping.' },
    { stage: 'PUBLISHED', label: 'Released & In Distribution', order: 10, description: 'Physical bookstore delivery, seminary catalog release, and digital distribution.' }
];
export const PARTNER_TYPES_CONFIG = {
    PUBLISHER_RIGHTS: { label: 'Publishing Rights Partner', description: 'Original copyright holders licensing translation and regional distribution.' },
    DISTRIBUTION: { label: 'Bookstore & Distribution', description: 'Retailers, distributor networks, and library suppliers.' },
    CHURCH_MINISTRY: { label: 'Church & Ministry Network', description: 'Denominations, church plants, and ministry bulk partners.' },
    TRANSLATION_ORGANIZATION: { label: 'Translation Consortium', description: 'Language translators, linguists, and biblical translation societies.' },
    ACADEMIC_INSTITUTION: { label: 'Seminary & Academic', description: 'Theological seminaries, colleges, and scholarly institutions.' },
    CO_PUBLISHER: { label: 'Co-Publishing Partner', description: 'Joint publishing ventures and regional imprint collaborators.' }
};
export const CUSTOMER_CRM_STAGES_CONFIG = {
    LEAD: { label: 'Initial Lead', color: 'blue' },
    OPPORTUNITY: { label: 'Proposal / Assessment', color: 'amber' },
    CONTRACT_SIGNED: { label: 'Contract Signed', color: 'purple' },
    IN_PRODUCTION: { label: 'In Active Production', color: 'indigo' },
    REPEAT_CLIENT: { label: 'Active Author / Client', color: 'emerald' },
    DORMANT: { label: 'Dormant', color: 'slate' }
};
export const STAFF_DEPARTMENTS_CONFIG = {
    MANAGEMENT: { label: 'Executive & Management' },
    EDITORIAL: { label: 'Editorial & Assessment' },
    TRANSLATION: { label: 'Translation & Vernaculars' },
    PRODUCTION_DESIGN: { label: 'Design & Pre-Press Production' },
    FINANCE_OPERATIONS: { label: 'Finance, Rights & Operations' },
    PARTNER_RELATIONS: { label: 'Partner & Author Relations' }
};
//# sourceMappingURL=index.js.map